module.exports = __webpack_public_path__ + "img/bughunt.710b3ad5.png";